import React from 'react';
import PropTypes from 'prop-types';
import bellIcon from '../../../assets/images/bell-icon.svg';

function ReviewAlert({ numberOfReviews }) {
  return (
    <a
      id="review-employer-alert"
      className="card-multi box-shadow-1 mb-3 g-row--always g-row--between"
      href="reviews"
    >
      <div className="reviews-card">
        <div className="icon">
          <img src={bellIcon} alt="review-alert-icon" />
        </div>
        <div className="details-multi">
          <strong>{numberOfReviews}</strong>
          {' '}
          consultant reviews pending
        </div>
      </div>
      <div className="icon">
        <i className="fas fa-chevron-right" />
      </div>
    </a>
  );
}

ReviewAlert.propTypes = {
  numberOfReviews: PropTypes.number,
};

ReviewAlert.defaultProps = {
  numberOfReviews: 1,
};

export default ReviewAlert;
